import React, { Component } from 'react';
import { Button, Card, Col, Row } from 'react-bootstrap';
import Container from 'react-bootstrap/Container';
import { RodapeImpressao } from '../../components/UtilComponent';
import * as Constants from '../../utils/constants';
import Header from './components/Header';


class Home extends Component {

    constructor() {
        super();
    }


    render() {
        return (
            <div>

                <Header />

                <Container className="text-muted">
                    <Row className="text-center">

                        <Col >
                            <Card style={{ border: 'none' }} >
                                {/* <Card.Img variant="top" src={Motorista} /> */}
                                <Card.Body>
                                    <Button variant="info" href={Constants.ROUTE_URL_TRANSPORTADORA} block>Cadastrar Transportadora</Button>
                                </Card.Body>
                            </Card>

                        </Col>
                        <Col >
                            <Card style={{  border: 'none' }} >
                                {/* <Card.Img variant="top" src={Truck} /> */}
                                <Card.Body>
                                    <Button variant="success" href={Constants.ROUTE_URL_PESAGEM} block>Realizar Pesagem</Button>
                                </Card.Body>
                            </Card>

                        </Col>

                        <Col >
                            <Card style={{ border: 'none' }} >
                                {/* <Card.Img variant="top" src={Fazendeiro} /> */}
                                <Card.Body>
                                    <Button variant="danger" href={Constants.ROUTE_URL_AGRICULTOR} block>Cadastrar Agricultor</Button>
                                </Card.Body>
                            </Card>

                        </Col>


                    </Row>
                    <RodapeImpressao bottom={true}/>
                </Container>

            </div>
        );
    }
};

export default Home;
